import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable()
export class MicrosoftDynamicsRedirectGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const urlSearchParams = new URLSearchParams(route.queryParams);
        const params = new URLSearchParams(window.location.search);
        const communityName = urlSearchParams.get('state');
        const queryParams = {};

        params.forEach((value, key) => {
            queryParams[key] = value;
        });

        queryParams['app'] = 'dynamics';

        if (communityName) {
            this.router.navigate([`/${communityName}/community/applications`], { queryParams });
        }

        return true;
    }
}
